import styles from './anagraphic.module.scss';
import { Anagraphic } from '../employees/employeeDetailsTabs/anagraphic/anagraphic';
import { Heading } from '../../atoms/heading/heading';

const AnagraphicPage = () => {
  return (
    <div className={styles.anagraphicPageContainer}>
      <div className={styles.formWrapper}>
        <Heading content="Modifica la tua anagrafica" size={2} />
        <Anagraphic />
      </div>
    </div>
  );
};

export default AnagraphicPage;
